module.exports = __webpack_public_path__ + "static/media/wide_named_logo_shagi_only.78ddadd2.png";